// Справочник контента для показа: имена боссов и приёмов (нарратив 05, 07), уровни открытия (ГД 06 §3).
// Числа здесь — только запасные значения для показа: сервер присылает их в bootstrap.clientConfig.values
// (`bosses.<id>.level`), и они перекрывают таблицу (решение каркаса Р-36, ADR-0010). Боевых чисел клиент не знает.
import type { BossId, MoveId } from './types.js';
import { ITEM_NAMES } from './items.gen.js';

export interface BossInfo {
  name: string;
  short: string;
  district: string;
  level: number;
  /** У людей полоса называется «Запал» (ux/04 §4.1). */
  hpLabel: 'Здоровье' | 'Запал';
  moves: Record<string, string>;
  color: number;
  win: string;
}

export const BOSSES: Record<string, BossInfo> = {
  B01: {
    name: 'Крыса Шушера', short: 'Шушера', district: 'D1', level: 2, hpLabel: 'Здоровье', color: 0x8a7f72,
    moves: { 'B01-M1': 'Укус', 'B01-M2': 'Перегрызть провод', 'B01-M3': 'Шмыг в нору' },
    win: 'Шушера юркнула в щель. Свет зажёгся.',
  },
  'B01-T': {
    name: 'Крыса Шушера', short: 'Шушера', district: 'D1', level: 1, hpLabel: 'Здоровье', color: 0x8a7f72,
    moves: { 'B01-T-M1': 'Укус' },
    win: 'Шушера юркнула в щель. Свет зажёгся.',
  },
  B02: {
    name: 'Сосед с перфоратором', short: 'Аркадич', district: 'D1', level: 4, hpLabel: 'Запал', color: 0x5f7fa3,
    moves: { 'B02-M1': 'Перфоратор', 'B02-M2': 'Пыль столбом', 'B02-M3': 'Стук по батарее' },
    win: 'Аркадич наконец снял беруши. Стало тихо.',
  },
  B03: {
    name: 'Ржавчина', short: 'Ржавчина', district: 'D1', level: 7, hpLabel: 'Здоровье', color: 0xb5562b,
    moves: { 'B03-M1': 'Разъедание металла', 'B03-M2': 'Ржавый налёт', 'B03-M3': 'Цветёт' },
    win: 'Ржавчина осыпалась. Металл снова блестит.',
  },
  B04: {
    name: 'Ревизор Палыч', short: 'Палыч', district: 'D1', level: 10, hpLabel: 'Запал', color: 0x4f5b4a,
    moves: { 'B04-M1': 'Штраф', 'B04-M2': 'Обход территории', 'B04-M3': 'Запись в журнал', 'B04-M4': 'Режим проверки' },
    win: 'Палыч закрыл журнал и ушёл пить чай.',
  },
  // D2–D3 и мировой W01 (E04-T07): имена — ГД 06 §3, нарратив 05; уровни открытия — ГД 06 §3 (запасные, сервер шлёт minLevel).
  B05: { name: 'Голуби-пачкуны', short: 'Голуби', district: 'D2', level: 12, hpLabel: 'Здоровье', color: 0x7d8a99, moves: { 'B05-M1': 'Карусель', 'B05-M2': 'Испачкать краску', 'B05-M3': 'Разлететься' }, win: '' },
  B06: { name: 'Перекупщик Жора', short: 'Жора', district: 'D2', level: 15, hpLabel: 'Запал', color: 0x8a6d3b, moves: { 'B06-M1': 'Сбить цену', 'B06-M2': 'Перекупить', 'B06-M3': 'Торг' }, win: '' },
  B07: { name: 'Кран-самоход', short: 'Кран', district: 'D2', level: 17, hpLabel: 'Здоровье', color: 0xc9a227, moves: { 'B07-M1': 'Груз сорвался', 'B07-M2': 'Стрела', 'B07-M3': 'Заклинило' }, win: '' },
  B08: { name: 'Бригада сноса', short: 'Бригада', district: 'D2', level: 20, hpLabel: 'Запал', color: 0xb5562b, moves: { 'B08-M1': 'Замер', 'B08-M2': 'Планёрка', 'B08-M3': 'Разметка под снос', 'B08-M4': 'Смена прораба' }, win: '' },
  B09: { name: 'Лужа-Океан', short: 'Лужа', district: 'D3', level: 22, hpLabel: 'Здоровье', color: 0x3f6f8f, moves: {}, win: '' },
  B10: { name: 'Эдик с чудо-присадкой', short: 'Эдик', district: 'D3', level: 25, hpLabel: 'Запал', color: 0x6a8f3f, moves: {}, win: '' },
  B11: { name: 'Эвакуатор-призрак', short: 'Эвакуатор', district: 'D3', level: 27, hpLabel: 'Здоровье', color: 0x5a5f73, moves: {}, win: '' },
  B12: { name: 'Застройщик Гранитов', short: 'Гранитов', district: 'D3', level: 30, hpLabel: 'Запал', color: 0x4f4a45, moves: {}, win: '' },
  W01: { name: 'Экскаватор «Прожора»', short: 'Прожора', district: 'W', level: 10, hpLabel: 'Здоровье', color: 0xd28a1e, moves: {}, win: '' },
};

export const DISTRICT_NAMES: Record<string, string> = { D1: 'Гаражный кооператив «Мотор-3»', D2: 'Промзона у элеватора', D3: 'Рынок у кольцевой' };
/** Уровни районов для заголовка ленты (ГД 06 §2). */
export const DISTRICT_LEVELS: Record<string, string> = { D1: '1–10', D2: '11–20', D3: '21–30' };

/** Названия приёмов игрока — narrative/07 `UI-SKILL-<id>`; уровни открытия — ux/04 §4.2. */
export const MOVES: Record<MoveId, { name: string; tip: string; row: 'main' | 'extra' }> = {
  strike: { name: 'Удар', tip: 'Простой удар. Всегда под рукой, ждать не надо', row: 'main' },
  wrench: { name: 'Бросок ключа', tip: 'Сильный бросок. Потом ключ надо подобрать', row: 'main' },
  chem: { name: 'Химия', tip: 'Разъедает босса. Защита не спасает', row: 'main' },
  torch: { name: 'Строительный фен', tip: 'Горячий воздух со всей силы', row: 'extra' },
  kit: { name: 'Передышка', tip: 'Перевести дух: вернёт часть сил', row: 'extra' },
  jack: { name: 'Домкрат', tip: 'Поддеть босса: он пропустит ход', row: 'extra' },
  weld: { name: 'Сварка встык', tip: 'Ослабит защиту босса', row: 'extra' },
};

export const SLOT_NAMES = { head: 'Голова', jacket: 'Куртка', pants: 'Штаны', shoes: 'Обувь', tool: 'Инструмент', accessory: 'Мелочь' } as const;
export const RARITY_NAMES = { common: 'обычная', good: 'хорошая', rare: 'редкая', epic: 'эпическая', legendary: 'легендарная' } as const;
export const STAT_NAMES = { attack: 'Атака', hp: 'Здоровье', def: 'Защита', crit: 'Крит', critMult: 'Сила крита', dodge: 'Уклон' } as const;

export function bossInfo(id: string, clientConfig?: Record<string, unknown>): BossInfo {
  const base = BOSSES[id] ?? { name: id, short: id, district: 'D1', level: 1, hpLabel: 'Здоровье' as const, moves: {}, color: 0x777777, win: '' };
  const override = (clientConfig?.['bosses'] as Record<string, { level?: number }> | undefined)?.[id];
  return override?.level ? { ...base, level: override.level } : base;
}

export function bossMoveName(bossMoveId: string): string {
  const bossId = bossMoveId.replace(/-M\d+$/, '');
  return BOSSES[bossId]?.moves[bossMoveId] ?? 'приём';
}

export function itemName(defId: string): string {
  return ITEM_NAMES[defId]?.name ?? defId;
}

export function itemDesc(defId: string): string {
  return ITEM_NAMES[defId]?.desc ?? '';
}

export function itemLevel(defId: string): number {
  return ITEM_NAMES[defId]?.level ?? 1;
}

/** С какого уровня игрока предмет можно надеть: Item.requiredLevel от сервера (Р-107), иначе каталог клиента. */
export function itemRequiredLevel(item: { defId: string; requiredLevel?: number | undefined }): number {
  return item.requiredLevel ?? itemLevel(item.defId);
}

/** «Рано»: не надет и требует уровня выше, чем у игрока (уровень неизвестен — не помечаем). */
export function itemTooEarly(item: { defId: string; requiredLevel?: number | undefined; equipped?: boolean }, level: number | null | undefined): boolean {
  return !item.equipped && level != null && itemRequiredLevel(item) > level;
}

export type { BossId };
